import clsx from 'clsx';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "hint": "pbui-R-8vv",
  "hint--no-error": "pbui-YhGqO",
  "hint--has-error": "pbui-49cjI",
  "label": "pbui-xvGoL",
  "container": "pbui-aT1-T",
  "input__container": "pbui-ui6BX",
  "input__container--disabled": "pbui-ZN8Wm",
  "input__container--has-error": "pbui-AM3ix",
  "dropdown": "pbui-iprEz",
  "input": "pbui-udKM8",
  "input--with-suffix-divider": "pbui-b1EtW",
  "suffix": "pbui-H7ZzL"
};
export var TelInputHint = function TelInputHint(_ref) {
  var children = _ref.children,
    hasError = _ref.hasError;
  var hintClasses = clsx(styles.hint, hasError ? styles['hint--has-error'] : styles['hint--no-error']);
  return /*#__PURE__*/_jsx("div", {
    className: hintClasses,
    children: children
  });
};